import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setPageNumberReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<number>) => {
    state.pageNumber = action.payload;
  });
};

export default setPageNumberReducer;
